import { PodborkaFindByUrlResponse } from "@project/shared-types";
import { useLoaderData, useLocation } from "react-router";
import { canonicalPath } from "../utils/canonical";
import { Footer } from "../blocks/Footer/Footer";
import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import { PodborkiList } from "../blocks/Podborki/PodborkiList";
import { UslugiBlock } from "../blocks/uslugi/UslugiBlock";
import { BreadCrumbs } from "../components/BreadCrumbs/BreadCrumbs";
import Header from "../components/header/header";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { UserProvider } from "../context/user/UserContext";
import "../core/core.css";
import { DataProvider } from "../hooks/DataContext";
import { SupportProvider } from "../Support/SupportProvider";

const Podborka = () => {
  const data = useLoaderData<PodborkaFindByUrlResponse>();
  const currentPage = useLocation();
  const breadLinks = [
    { url: "/", name: "Главная" },
    {
      url: currentPage.pathname,
      name: "Подборка",
    },
  ];

  return (
    <DataProvider>
      <title>{data.podborka?.title}</title>
      <meta name="description" content={data.podborka?.description} />
      <link
        rel="canonical"
        href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
      />
      <UserProvider>
        <SupportProvider>
          <div className="body">
            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <BreadCrumbs links={breadLinks}></BreadCrumbs>

              <UslugiBlock
                title={`${data.podborka?.content.cta}`}
                product_ids={data.podborka?.content.services}
              >
                <PodborkiList podborki={data.podborki}></PodborkiList>
              </UslugiBlock>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};

export default Podborka;
